<template>
  <button :type="type" :class="classes" :style="btnStyle" :disabled="isDisabled" @click="handleClick">
    <slot>{{ label }}</slot>
  </button>
</template>

<script>
export default {
  name: "SmagriaButton",
  props: {
    label: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "button",
    },
    block: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    action: {
      // optional async handler returning a promise
      type: Function,
      default: null,
    },
    customClass: {
      type: [String, Array, Object],
      default: "",
    },
    width: {
      type: [String, Number],
      default: null,
    },
    maxWidth: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      pending: false,
    };
  },
  computed: {
    isDisabled() {
      return this.disabled || this.pending;
    },
    classes() {
      return ["smagria-btn", this.block ? "smagria-btn--block" : "", this.pending ? "is-pending" : "", this.customClass];
    },
    btnStyle() {
      const style = {};
      if (this.width !== null && this.width !== undefined && this.width !== "") {
        const width = typeof this.width === "number" ? `${this.width}px` : this.width;
        style.width = width;
        style.maxWidth = width;
      }
      if (this.maxWidth !== null && this.maxWidth !== undefined && this.maxWidth !== "") {
        style.maxWidth = typeof this.maxWidth === "number" ? `${this.maxWidth}px` : this.maxWidth;
      }
      return style;
    },
  },
  methods: {
    async handleClick(event) {
      if (this.isDisabled) return;
      this.pending = true;
      this.$emit("click", event, this.done);
      try {
        if (this.action) {
          const maybePromise = this.action(event);
          if (maybePromise && typeof maybePromise.then === "function") {
            await maybePromise;
          }
        }
        this.$emit("done");
      } catch (err) {
        this.$emit("error", err);
      } finally {
        this.pending = false;
      }
    },
    done() {
      this.pending = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/global/colors.scss";

.smagria-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  max-width: 350px;
  height: 40px;
  border-radius: 50px;
  padding: 0 16px;
  border: none;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  background: transparent;
  transition: background-color 150ms ease;
}

.smagria-btn--block {
  width: 100%;
}

.smagria-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.is-pending {
  cursor: wait;
}

.smagria-btn.primary {
  background-color: $selection-color;
  color: #fff;
}

.smagria-btn.success {
  background-color: $success-color;
  color: #fff;
}

.smagria-btn.green {
  background-color: $brand;
  color: $white;
}

.smagria-btn.green:hover:not(:disabled) {
  background-color: $brand-dark;
  cursor: pointer;
}

.smagria-btn.danger {
  background-color: $danger-color;
  color: #fff;
}

.smagria-btn.reset {
  background: $gray-10;
  color: $brand-dark;
}

.smagria-btn.secondary {
  background: $gray-8;
  color: $gray-70;
}

.smagria-btn.border {
  border: 1px solid $gray-60 !important;
}

.smagria-btn.margin-left {
  margin-left: 8px;
}

.smagria-btn.margin-top {
  margin-top: 20px;
}

.smagria-btn.margin-bottom {
  margin-bottom: 20px;
}

.smagria-btn.no-border-radius {
  border-radius: 0 !important;
}
</style>
